module.exports = __webpack_public_path__ + "static/media/ASHOKLEY.ab8e69a2.txt";